/*
|---------------------------------------------------
| Importing components
|---------------------------------------------------
*/

import Home from 'components/Dashboard'

import Login from 'components/Login'

import Welcome from 'components/setup-guide/Welcome'

import UserList from 'components/user/UserList'
import UserDetails from 'components/user/UserDetails'

import UserLevelList from 'components/user-level/UserLevelList'
import UserLevelDetails from 'components/user-level/UserLevelDetails'

import OwnerList from 'components/owner/OwnerList'
import OwnerDetails from 'components/owner/OwnerDetails'

import OrganizationList from 'components/organization/OrganizationList'
import OrganizationDetails from 'components/organization/OrganizationDetails'

import ScheduledJobPanel from 'components/scheduled-job/ScheduledJobPanel'

import ServerDetails from 'components/server/ServerDetails'

import ControllerList from 'components/controller/ControllerList'
import ControllerDetails from 'components/controller/ControllerDetails'

import SwitchList from 'components/switch/SwitchList'
import SwitchDetails from 'components/switch/SwitchDetails'

import SwitchGroupList from 'components/switch-group/SwitchGroupList'
import SwitchGroupDetails from 'components/switch-group/SwitchGroupDetails'

import MobileList from 'components/mobile/MobileList'
import MobileDetails from 'components/mobile/MobileDetails'
import SingleMobileAccess from 'components/access/SingleMobileAccess'
import SingleSwitchAccess from 'components/access/SingleSwitchAccess'
import RestoreMobileAccess from 'components/mobile/RestoreMobileAccess'

import MobileGroupList from 'components/mobile-group/MobileGroupList'
import MobileGroupDetails from 'components/mobile-group/MobileGroupDetails'

import LocationList from 'components/location/LocationList'
import LocationDetails from 'components/location/LocationDetails'

import EventList from 'components/event/EventList'
import { ENTRY, REGISTRATION, SYSTEM, INPUT } from 'components/event/profiles'

import PreregistrationList from 'components/preregistration/PreregistrationList'
import PreregistrationDetails from 'components/preregistration/PreregistrationDetails'

import AccessSchemeList from 'components/access-scheme/AccessSchemeList'
import AccessSchemeDetails from 'components/access-scheme/AccessSchemeDetails'

import PendingAccessList from 'components/access/PendingAccessList'

import ExternalServiceList from 'components/external-service/ExternalServiceList.vue'
import ExternalServiceDetails from 'components/external-service/ExternalServiceDetails.vue'

import SystemParameterList from 'components/system-parameter/SystemParameterList'

/*
|---------------------------------------------------
| Creating route aliases
|---------------------------------------------------
*/

const GROUP_ADMININSTRATION = 'administration'
const GROUP_DEVICES = 'devices'
const GROUP_MONITORING = 'monitoring'

export const HOME = 'home'

export const LOGIN = 'login'

export const WELCOME = 'welcome'

export const USERS = 'user-list'
export const USER_EDIT = 'user-edit'

export const USER_LEVELS = 'user-level-list'
export const USER_LEVEL_EDIT = 'user-level-edit'

export const OWNERS = 'owner-list'
export const OWNER_EDIT = 'owner-edit'

export const ORGANISATIONS = 'organization-list'
export const ORGANISATION_EDIT = 'organization-edit'

export const SCHEDULED_JOBS = 'scheduled-jobs'

export const SERVER_DETAILS = 'server-details'
export const CHILD_SERVER_DETAILS = 'child-server-details'

export const CONTROLLERS = 'controller-list'
export const CONTROLLER_EDIT = 'controller-edit'

export const SWITCH_GROUPS = 'switch-group-list'
export const SWITCH_GROUP_EDIT = 'switch-group-edit'

export const MOBILES = 'mobile-list'
export const MOBILE_EDIT = 'mobile-edit'

export const SWITCHES = 'switch-list'
export const SWITCH_EDIT = 'switch-edit'

export const SINGLE_MOBIL_ACCESS = 'single-mobil-access'
export const SINGLE_SWITCH_ACCESS = 'single-switch-access'

export const RESTORE_MOBILE_ACCESS = 'restore-mobile-access'

export const MOBILE_GROUPS = 'mobile-group-list'
export const MOBILE_GROUP_EDIT = 'mobile-group-edit'

export const LOCATIONS = 'location-list'
export const LOCATION_EDIT = 'location-edit'

export const EVENTS = 'event-list'

export const PREREGISTRATIONS = 'preregistration-list'
export const PREREGISTRATIONS_EDIT = 'preregistration-edit'
export const PREREGISTRATIONS_CREATE = 'preregistration-create'

export const ACCESS_SCHEMES = 'access-schemes-list'
export const ACCESS_SCHEMES_EDIT = 'access-scheme-edit'

export const PENDING_ACCESSES = 'pending-access-list'

export const EXTERNAL_SERVICES = 'external-service-list'
export const EXTERNAL_SERVICE_EDIT = 'external-service-edit'

export const SYSTEM_PARAMETERS = 'system-parameter-list'

/*
|---------------------------------------------------
| Exporting application routes
|---------------------------------------------------
*/
const hideFromNav = true

export default [
  { path: '/', name: HOME, component: Home, meta: { hideFromNav } },
  { path: '/login', name: LOGIN, component: Login, meta: { hideFromNav } },
  { path: '/welcome', name: WELCOME, component: Welcome, meta: { hideFromNav } },

  // ==== Administration

  { path: '/users', name: USERS, component: UserList, meta: { permission: 'VIEW_USERS', group: GROUP_ADMININSTRATION } },
  { path: '/users/:id', name: USER_EDIT, component: UserDetails, meta: { hideFromNav, permission: 'VIEW_USERS' } },

  { path: '/user-levels', name: USER_LEVELS, component: UserLevelList, meta: { permission: 'VIEW_USER_LEVELS', group: GROUP_ADMININSTRATION } },
  { path: '/user-levels/:id', name: USER_LEVEL_EDIT, component: UserLevelDetails, meta: { hideFromNav, permission: 'VIEW_USER_LEVELS' } },

  { path: '/mobiles', name: MOBILES, component: MobileList, meta: { permission: 'VIEW_MOBILES', group: GROUP_ADMININSTRATION } },
  { path: '/mobiles/:id', name: MOBILE_EDIT, component: MobileDetails, meta: { hideFromNav, permission: 'VIEW_MOBILES' } },

  { path: '/access/mobile/:id', name: SINGLE_MOBIL_ACCESS, component: SingleMobileAccess, meta: { hideFromNav, permission: 'VIEW_SINGLE_MOBILE_ACCESSES' } },
  { path: '/access/switch/:id', name: SINGLE_SWITCH_ACCESS, component: SingleSwitchAccess, meta: { hideFromNav, permission: 'VIEW_SINGLE_MOBILE_ACCESSES' } },

  { path: '/mobile/restore/:id', name: RESTORE_MOBILE_ACCESS, component: RestoreMobileAccess, meta: { hideFromNav, permission: 'RESTORE_MOBILE_ACCESSES' } },

  { path: '/preregistrations', name: PREREGISTRATIONS, component: PreregistrationList, meta: { permission: 'VIEW_PREREGISTRATIONS', group: GROUP_ADMININSTRATION } },
  { path: '/preregistrations/edit/:preregId', name: PREREGISTRATIONS_EDIT, component: PreregistrationDetails, meta: { hideFromNav, permission: 'VIEW_PREREGISTRATIONS', group: GROUP_ADMININSTRATION } },
  { path: '/preregistrations/create/:controllerId', name: PREREGISTRATIONS_CREATE, component: PreregistrationDetails, meta: { hideFromNav, permission: 'VIEW_PREREGISTRATIONS', group: GROUP_ADMININSTRATION } },

  { path: '/mobile-groups', name: MOBILE_GROUPS, component: MobileGroupList, meta: { permission: 'VIEW_MOBILE_GROUPS', group: GROUP_ADMININSTRATION } },
  { path: '/mobile-groups/:id', name: MOBILE_GROUP_EDIT, component: MobileGroupDetails, meta: { hideFromNav, permission: 'VIEW_MOBILE_GROUPS' } },

  { path: '/switch-groups', name: SWITCH_GROUPS, component: SwitchGroupList, meta: { permission: 'VIEW_SWITCH_GROUPS', group: GROUP_ADMININSTRATION } },
  { path: '/switch-groups/:id', name: SWITCH_GROUP_EDIT, component: SwitchGroupDetails, meta: { hideFromNav, permission: 'VIEW_SWITCH_GROUPS' } },

  { path: '/locations', name: LOCATIONS, component: LocationList, meta: { permission: 'VIEW_LOCATIONS', group: GROUP_ADMININSTRATION } },
  { path: '/locations/:id', name: LOCATION_EDIT, component: LocationDetails, meta: { hideFromNav, permission: 'VIEW_LOCATIONS' } },

  { path: '/owners', name: OWNERS, component: OwnerList, meta: { permission: 'VIEW_OWNERS', group: GROUP_ADMININSTRATION } },
  { path: '/owners/:id', name: OWNER_EDIT, component: OwnerDetails, meta: { hideFromNav, permission: 'VIEW_OWNERS' } },

  { path: '/organizations', name: ORGANISATIONS, component: OrganizationList, meta: { permission: 'VIEW_ORGANIZATIONS', group: GROUP_ADMININSTRATION } },
  { path: '/organizations/:id', name: ORGANISATION_EDIT, component: OrganizationDetails, meta: { hideFromNav, permission: 'VIEW_ORGANIZATIONS' } },

  { path: '/scheduled-jobs', name: SCHEDULED_JOBS, component: ScheduledJobPanel, meta: { permission: 'VIEW_SCHEDULED_JOBS', group: GROUP_ADMININSTRATION } },

  { path: '/access-schemes', name: ACCESS_SCHEMES, component: AccessSchemeList, meta: { permission: 'VIEW_ACCESS_SCHEMES', group: GROUP_ADMININSTRATION } },
  { path: '/access-schemes/:id', name: ACCESS_SCHEMES_EDIT, component: AccessSchemeDetails, meta: { hideFromNav, permission: 'VIEW_ACCESS_SCHEMES' } },

  { path: '/pending', name: PENDING_ACCESSES, component: PendingAccessList, meta: { permission: 'VIEW_SINGLE_MOBILE_ACCESSES', group: GROUP_ADMININSTRATION } },

  { path: '/external-services', name: EXTERNAL_SERVICES, component: ExternalServiceList, meta: { permission: 'VIEW_EXTERNAL_SERVICES', group: GROUP_ADMININSTRATION } },
  { path: '/external-services/:id', name: EXTERNAL_SERVICE_EDIT, component: ExternalServiceDetails, meta: { hideFromNav, permission: 'VIEW_EXTERNAL_SERVICES' } },

  { path: '/system-parameter', name: SYSTEM_PARAMETERS, component: SystemParameterList, meta: { permission: 'VIEW_SYSTEM_PARAMETERS', group: GROUP_ADMININSTRATION } },

  // ==== Devices

  { path: '/server', name: SERVER_DETAILS, component: ServerDetails, meta: { permission: 'VIEW_SERVERS', group: GROUP_DEVICES } },
  { path: '/server/:id', name: CHILD_SERVER_DETAILS, component: ServerDetails, meta: { hideFromNav, permission: 'VIEW_SERVERS' } },
  { path: '/controllers', name: CONTROLLERS, component: ControllerList, meta: { permission: 'VIEW_CONTROLLERS', group: GROUP_DEVICES } },
  { path: '/controllers/:id', name: CONTROLLER_EDIT, component: ControllerDetails, meta: { hideFromNav, permission: 'VIEW_CONTROLLERS' } },
  { path: '/switches', name: SWITCHES, component: SwitchList, meta: { permission: 'VIEW_SWITCHES', group: GROUP_DEVICES } },
  { path: '/switches/:id', name: SWITCH_EDIT, component: SwitchDetails, meta: { hideFromNav, permission: 'VIEW_SWITCHES' } },

  // ==== Monitoring

  { path: '/events/entry', name: `${EVENTS}-entry`, component: EventList, meta: { permission: 'VIEW_EVENTS', group: GROUP_MONITORING, profile: ENTRY } },
  { path: '/events/registration', name: `${EVENTS}-registration`, component: EventList, meta: { permission: 'VIEW_EVENTS', group: GROUP_MONITORING, profile: REGISTRATION } },
  { path: '/events/system', name: `${EVENTS}-system`, component: EventList, meta: { permission: 'VIEW_EVENTS', group: GROUP_MONITORING, profile: SYSTEM } },
  { path: '/events/input', name: `${EVENTS}-input`, component: EventList, meta: { permission: 'VIEW_EVENTS', group: GROUP_MONITORING, profile: INPUT } },

  // ==== Controll

  { path: '*', redirect: HOME, meta: { hideFromNav } }
]



// WEBPACK FOOTER //
// ./src/router/routes.js